export default [
    {
        name: "name",
        label: "Name",
        type: "string",
    },
    {
        name: "batteryLevel",
        label: "Battery Level",
        type: "string",
    },
    {
        name: "deviceModelName",
        label: "Device Model Name",
        type: "string",
    },
    {
        name: "imei",
        label: "IMEI",
        type: "string",
    },
    {
        name: "manufacturer",
        label: "Manufacturer",
        type: "string",
    },
    {
        name: "mdmId",
        label: "MDM ID",
        type: "string",
    },
    {
        name: "lastContactTime",
        label: "Last Contact Time",
        type: "date",
    },
    {
        name: "lastScanTime",
        label: "Last Scan Time",
        type: "date",
    },
    {
        name: "addedTime",
        label: "Adding Dat",
        type: "date",
    },
];
